module.exports = __webpack_public_path__ + "img/NoPath3@2x.60d77330.png";